// TODO [refactor] see MemberPurchaseItemPage.js, GuestPurchaseItemPage.js

import { useState, useCallback, useMemo } from 'react'
import { connect } from 'react-redux'
import {
  checkoutTapPayInstalmentAction,
  loadTapPaySDKAction,
} from '../../actions/tapPayActions'
import {
  formatNumber,
  remove886,
  to886,
  toSegmentedPhoneNumber,
} from '../../libs/utils'
import TableRow from '../babu/TableRow'
import BottomButtonArea from '../common/BottomButtonArea'
import NavBar from '../common/NavBar'
import useGA4Pageview from '../libs/hooks/useGA4Pageview'
import { memberOrGuestIdSelector } from '../libs/selectors'
import TapPayPaymentPage from '../tappay/TapPayPaymentPage'
import AgreeTermsCard from './AgreeTermsCard'
import ConfirmPurchaseTopArea from './ConfirmPurchaseTopArea'
import SelectPaymentCard from './SelectPaymentCard'

/*
  instalmentInfo: {
      "order_number": "CAO0000008724",  // 訂單編號
      "title": "團購名稱",
      "price": 2000,              // 商品金額 (台幣)
      "mobile": "0933123456",     // 買家手機號碼，讓買家登入時驗證是否為同一位買家
      "contact": "+886912345678", // 賣家手機號碼 (for aifianBuyer-3)
      "instalment": 6,            // 分期期數
      "instalment_amount": 333,   // 分期金額 (台幣/一期)
      "payment_amount": 335,      // 不分期/首期應付金額 (台幣)
      "exchange_rate": 31,        // 台幣兌美元匯率
      "statuses": [
        {
          "period_num": 1,       // 第一期
          "payment_amount": 335, // 分期金額
          "status": "success"    // success (已付款); processing (待付款); init (未付款)
        },
        {
          "period_num": 2,       // 第二期
          "payment_amount": 333,
          "status": "init"
        },
        …
      ]
  }
 */

/*
  props: instalmentInfo, userId, loadSDK, checkoutTapPay
 */
function PurchaseInstalment(props) {
  const [openTapPay, setOpenTapPay] = useState(false)
  const [agreed, setAgreed] = useState(false)

  const checkoutButtonCallback = useCallback(() => {
    if (agreed) {
      setOpenTapPay(true)
    }
  }, [agreed, setOpenTapPay])

  const { orderNo, instalmentInfo, username, userId, loadSDK, vendorInfo } =
    props

  const { exchange_rate: exchangeRate } = instalmentInfo

  const periods = useMemo(
    () =>
      instalmentInfo.statuses
        .filter(status => status.status === 'processing')
        .map(status => `${status.period_num}`),
    [instalmentInfo],
  )

  const amount = useMemo(
    () =>
      instalmentInfo.statuses
        .filter(status => status.status === 'processing')
        .reduce((acc, cur) => acc + cur.payment_amount, 0),
    [instalmentInfo],
  )

  const loadSDKCallback = useCallback(() => {
    loadSDK(
      { orderNo },
      username
        ? {
            orderNo,
            member_id: userId,
            mobile: to886(username),
          }
        : null,
    )
  }, [orderNo, username, userId, loadSDK])

  useGA4Pageview('slash_checkout_creditcard')

  if (openTapPay) {
    return (
      <TapPayPaymentPage
        price={amount}
        onCancel={() => setOpenTapPay(false)}
        onCheckout={() => {
          props.checkoutTapPay(instalmentInfo.period_id, userId)
        }}
        loadSDK={loadSDKCallback}
        toPurchaseLoginPage={props.toPurchaseLoginPage}
      />
    )
  }

  return (
    <>
      <NavBar />
      <BottomButtonArea
        variant="solid"
        disabled={!agreed}
        onClick={checkoutButtonCallback}>
        {`支付 NT$${formatNumber(amount)}`}
      </BottomButtonArea>
      <ConfirmPurchaseTopArea
        phone={username}
        amount={amount}
        amountUSD={amount / exchangeRate}
      />
      <div className="container px-xs">
        {vendorInfo ? (
          <TableRow
            content="收款商家"
            accessoryLabel={vendorInfo.name}
            divided
          />
        ) : (
          <TableRow
            content="賣家手機"
            accessoryLabel={toSegmentedPhoneNumber(
              remove886(instalmentInfo.contact),
            )}
            divided
          />
        )}
        <TableRow
          content="名稱"
          accessoryLabel={instalmentInfo.title}
          divided
        />
        <TableRow content="期數" accessoryLabel={periods.join('、')} divided />
      </div>
      <div className="container mt-l mb-30">
        <SelectPaymentCard />
        <AgreeTermsCard
          agreed={agreed}
          setAgreed={setAgreed}
          cardClassName="mt-m"
        />
      </div>
    </>
  )
}

export default connect(
  state => ({
    userId: memberOrGuestIdSelector(state.user, state.sms),
    instalmentInfo: state.itemEntry.buyerInstalments,
    username: state.user.username || state.sms.sentPhone,
    vendorInfo: state.vendor.vendorInfo,
  }),
  dispatch => ({
    checkoutTapPay(periodId, userId) {
      dispatch(
        checkoutTapPayInstalmentAction({
          member_id: userId,
          period_id: periodId,
        }),
      )
    },
    loadSDK(memberQuery, guestPayload) {
      dispatch(loadTapPaySDKAction(memberQuery, guestPayload))
    },
  }),
)(PurchaseInstalment)
